import request from '@/utils/axios'
import type { ResPage } from '@/apis/interface/index'
import type { User } from '@/apis/interface/userManage'
import { ContentTypeEnum } from '@/enums/axios'
import { saveAs } from 'file-saver'
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

/**
 * @name 用户管理模块
 */
// * 获取用户列表
export const getUserList = (params: User.ReqUserParams) => {
  return request.post<ResPage<User.ResUserList>>('/admin/user/page', params, jsonHeaderConfig)
}

// * 获取用户列表(不走权限，全部返回)
export const getUserListNoAuth = (params: User.ReqUserParams) => {
  return request.post<ResPage<User.ResUserList>>('/admin/user/loadUser', params, jsonHeaderConfig)
}

// * 获取树形部门列表
export const getDepartmentTree = (data = undefined) => {
  return request.post<ResPage<User.ResDepartment>>('/admin/department/tree', data)
}

// * 新增用户
export const addUser = (params: User.ReqAddUserParams) => {
  return request.post('/admin/user/add', params, jsonHeaderConfig)
}

// * 修改用户
export const editUser = (params: User.ReqAddUserParams) => {
  return request.post('/admin/user/update', params, jsonHeaderConfig)
}

// * 用户详情
export const getUserDetail = (id: number) => {
  return request.post('/admin/user/detail', { id })
}

// * 根据部门ID查询当前部门主管
export const getManagerByDepartmentId = (params: {
  departmentId: number
  userId: number | undefined
}) => {
  return request.request({
    url: '/admin/department/manager',
    params
  })
}

/**
 * 用户启用禁用
 * @param params DISABLED  禁用'|'DRAFT'|'ENABLED 启用
 */
export const updateUser = (params: { id: number; state: 'DISABLED' | 'DRAFT' | 'ENABLED' }) => {
  return request.post('/admin/user/enable', params)
}
// 批量启用禁用
export const updateUserBatch = (params: {
  ids: number[]
  state: 'DISABLED' | 'DRAFT' | 'ENABLED'
}) => {
  return request.post('/admin/user/enable/batch', params)
}

export const userResign = (params: { id: number; followId: number }) => {
  return request.post('/admin/user/resign', params)
}

// 批量重置角色
export const resetRoleBatch = (data: any) => {
  return request.post('/admin/user/update/role/batch', data, jsonHeaderConfig)
}

// 批量重置部门
export const resetDepartmentBatch = (data: any) => {
  return request.post('/admin/user/update/dept/batch', data, jsonHeaderConfig)
}

// *自动生成账号密码
export const createUserPassword = () => {
  return request.get('/admin/user/createUserPassword', {})
}
// 该员工存在个人账户
export const checkHaveUserAccount = (data: any) =>
  request.post('/financial/userAccountAuth/checkHaveUserAccount', data)
// 编辑员工校验
export const checkHasUserAccountAuth = (data: any) =>
  request.post('/financial/userAccountAuth/checkHasUserAccount', data, jsonHeaderConfig)

// 下载员工上传模板
export const downloadPersonFile = () => {
  return request
    .get('/admin/user/download', null, {
      responseType: 'blob'
    })
    .then(res => {
      const blob = new Blob([res.data])
      const name = res.filename
        ? res.filename
        : new Date().getTime() + '_' + parseInt(Math.random() * 10000) + '.xlsx'
      saveAs(blob, name)
    })
    .finally(() => {})
}

// 下载员工上传错误文件
export const downloadPersonUploadError = (userImportErrorKey: any) => {
  return request
    .get(`/admin/user/download/${userImportErrorKey}`, null, {
      responseType: 'blob'
    })
    .then(res => {
      const blob = new Blob([res.data])
      const name = res.filename
        ? res.filename
        : new Date().getTime() + '_' + parseInt(Math.random() * 10000) + '.xlsx'
      saveAs(blob, name)
    })
    .finally(() => {})
}

// 修改账号密码
export const updatePassword = (data: any) =>
  request.post('/admin/user/profile/password', data, jsonHeaderConfig)
// 导出组织架构
export const deptExport = '/admin/department/export'

// cps是否是二级部门管理员
export const isSecondaryDepartmentManager = (data: any) => {
  return request.post(
    '/admin/cps/storeManagement/isSecondaryDepartmentManager',
    data,
    jsonHeaderConfig
  )
}

// 门店认证
export const cpsStoreManagementCertification = (data: any) => {
  return request.post('/admin/cps/storeManagement/certification', data, jsonHeaderConfig)
}

// 门店认证 2级部门
export const getSecondaryDpt = (data: any) => {
  return request.post('/admin/department/cps/list', data, jsonHeaderConfig)
}

// 获取门店认证详情
export const getStoreCertificationDetail = (data: any) => {
  return request.get('/admin/cps/storeManagement/auth/detail/' + data.id, null, jsonHeaderConfig)
}

// 获取所有2及部门 不受权限控制
export const getAllSecondaryDpt = (data: any) => {
  return request.post('/admin/department/cps/allList', data, jsonHeaderConfig)
}

// 账号限制
export const accountLimit = (data: any) => {
  return request.post('/admin/user/accountLimit', data)
}

// 获取设备激活码
export const getActivationCode = (data: any) => {
  return request.post('/admin/mdm/getActivationCode', data)
}

// 获取财智通资质
// 功能下线：DIS 网关 gw.youljrong.com 不可用，暂不请求 /dis/h5/getSysParamByCode?code=get_flair_config_key
export const getSpecialize = () => {
  // return request.get('/dis/h5/getSysParamByCode', { code: 'get_flair_config_key' })
  return Promise.resolve(null)
}
